import { Modal, Row, Col, Divider, Carousel } from "antd";
import React, { useRef, useState } from "react";
import "./custom.scss";
import {
  MdOutlineArrowBackIos,
  MdOutlineArrowForwardIos,
} from "react-icons/md";
import {
  FaCalendarDay,
  FaTachometerAlt,
  FaCarCrash,
  FaCar,
  FaUsers,
} from "react-icons/fa";
import { GiGearStickPattern, GiGears } from "react-icons/gi";
import { IoMdPin } from "react-icons/io";
import NoImage from "./noImage";

const CustomVideoView = (props) => {
  const { data, title, onCancel, visible } = props;

  const slider = useRef();

  const next = () => {
    slider.current.next();
  };

  const prev = () => {
    slider.current.prev();
  };

  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      className="preview-modal"
    >
      {!Object.entries(data).length ? null : (
        <div className="product-container">
          <div className="image-container">
            {!data.video_url ? (
              <NoImage />
            ) : (
              <video
                src={data.video_url}
                controls
                poster={data.cover_image}
                width="100%"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  width: "100%",
                }}
              />
            )}
          </div>

          <div className="header-name-container">
            <div style={{ marginTop: 20 }}>
              <p className="name">{data?.title}</p>
            </div>
          </div>

          <div className="overview">
            <p className="header-section">Description</p>
            <p>{data?.description}</p>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default CustomVideoView;
